import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import withdrawConfirm from '@/components/wallet/withdraw-confirm/withdraw-confirm.vue';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import availableBalance from '@/components/wallet/available-balance/available-balance.vue';
import { formMixin, validators } from '@/components/forms/mixin';
import documentUploadMixin from '@/mixins/documentUpload';
import contentLoaderMixin from '@/mixins/contentLoader';
import { roundDown } from '@/utils/helpers';

export default {
  mixins: [
    contentLoaderMixin,
    documentUploadMixin,
    formMixin,
  ],
  components: {
    alertBox,
    availableBalance,
    withdrawConfirm,
  },
  validations() {
    return {
      fields: {
        amount: validators.withdrawalAmount(this.minWithdrawal, this.maxWithdrawal),
      },
    };
  },
  created() {
    this.checkWithdrawCheck();
  },
  data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        street: '',
        city: '',
        zipCode: '',
        amount: '',
        country: '',
      },
    };
  },
  watch: {
    check(value) {
      this.fields.country = value.countryCode;
      this.fields.street = value.address1;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;
    },
  },
  computed: {
    ...mapState('wallet', ['check']),
    availableBalance() {
      return (this.check && this.check.availableFundsString) ? this.check.availableFundsString : '$0.00';
    },
    restrictedFunds() {
      return (this.check && this.check.restrictedFundsString) ? this.check.restrictedFundsString : '';
    },
    minWithdrawal() {
      return (this.maxWithdrawal > 0) ? 1 : 0;
    },
    maxWithdrawal() {
      return this.check ? roundDown(this.check.availableFunds) : 0;
    },
    isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage() {
      return this.error || this.check.errorMessage;
    },
    hasErrorMessage() {
      return this.error || !!this.check.errorMessage;
    },
  },
  methods: {
    ...mapActions('user', ['getVerifyID']),
    ...mapActions('wallet', ['getWithdrawCheck']),
    onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCheck();
      this.$emit('success');
    },
    onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCheck() {
      this.getWithdrawCheck()
        .then((data) => {
          this.checkDocumentUploadFlags(data);
          this.isComponentReady = true;
        })
        .catch((error) => {
          this.isComponentReady = true;
          this.error = get(error, 'response.data.message', '');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/check/check.js